import * as Yup from 'yup';

export const getIncidentReviewDetailSchema = (step: number) => {
  if (step === 1) {
    return Yup.object();
  } else if (step === 2) {
    return Yup.object().shape({
      date: Yup.string().required('Date is required'),
      time: Yup.string().required('Time is required'),
      department: Yup.string().required('Department is required'),
      assignee: Yup.array()
        .of(Yup.string())
        .min(1, 'At least one assignee is required')
        .test('max', 'You can assign up to 5 people only', function (value) {
          return !value || value.length <= 5;
        })
        .required('Assignee is required'),
      leadAssignee: Yup.string().when('assignee', {
        is: (assignee: string[]) => assignee?.length >= 2,
        then: (schema) => schema.required('Lead Assignee is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
      actionPriority: Yup.string().required('Action Priority is required'),
      actionTitle: Yup.string().required('Action Title is required'),
      description: Yup.string().required('Description is required'),
    });
  } else {
    return Yup.object();
  }
};
